'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/index.js';
exports.default = Message;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _componentThemes$mess = _themes.componentThemes.message,
  messageStyle = _componentThemes$mess.messageStyle,
  messageVariants = _componentThemes$mess.messageVariants,
  messageTheme = _componentThemes$mess.messageTheme;
var wrapperStyles = function wrapperStyles(props) {
  return {
    paddingBottom: props.theme.space_md
  };
};
var messageStyles = function messageStyles(props) {
  var theme = messageTheme(props.theme);
  return _defineProperty({
    padding: '1rem',
    borderWidth: theme[messageStyle('borderWidth')],
    borderStyle: theme[messageStyle('borderStyle')],
    borderColor: theme[messageStyle('borderColor', messageVariants[props.type])],
    color: theme[messageStyle('color', messageVariants[props.type])],
    backgroundColor: theme[messageStyle('backgroundColor', messageVariants[props.type])],
    position: 'relative'
  }, '& > a', {
    color: theme[messageStyle('color', messageVariants[props.type])],
    textDecoration: 'underline'
  });
};
Message.propTypes = {
  type: (0, _propTypes.oneOf)(['help', 'error', 'success', 'warning']).isRequired,
  children: _propTypes.node.isRequired
};
var Wrapper = _glamorous2.default.div(wrapperStyles);
var MessageComponent = _glamorous2.default.div(messageStyles);
function Message(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ['children']);
  return _react2.default.createElement(Wrapper, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40
    },
    __self: this
  }), _react2.default.createElement(MessageComponent, {
    type: props.type,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: this
  }, children));
}